import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import events from '@/hooks/events';
import actions from '../constants';

const useEditDataset = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ template }) => handler({
    type: actions.EDIT_DATASET, category, code, template,
  }), [category, code]);
};

const useUpdateDatasetProperties = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ properties }) => handler({
    type: actions.UPDATE_DATASET_PROPERTIES, category, code, properties,
  }), [category, code]);
};

const useUpdataDatasetValidationErrors = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ errors }) => handler({
    type: actions.UPDATE_DATASET_VALIDATION_ERRORS, category, code, errors,
  }), [category, code]);
};

const useUpdateActiveDatasetStep = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ step, template }) => handler({
    type: actions.UPDATE_DATASET_STEP, category, code, step, template,
  }), [category, code]);
};

const useCreateDataset = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ template }) => handler({
    type: actions.CREATE_DATASET, category, code, template,
  }), [category, code]);
};

const useUpdateDataset = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ properties, template }) => handler({
    type: actions.UPDATE_DATASET, category, code, properties, template,
  }), [category, code]);
};

const useUpdateDatasetCatalogue = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ catalogue, template }) => handler({
    type: actions.UPDATE_DATASET_CATALOGUE, category, code, catalogue, template,
  }), [category, code]);
};

const useDownloadDataset = ({ code }) => {
  const handler = useDispatch();
  return useCallback(() => handler({ type: actions.DOWNLOAD_DATASET, code }), [code]);
};

const useUpdateDatasetsDataModelFilter = (category) => {
  const handler = useDispatch();
  return useCallback(({ dataModelCode }) => handler({
    type: actions.UPDATE_DATASETS_DATA_MODEL_FILTER, category, dataModelCode,
  }), [category]);
};

const useCreateAndConvertToDictionary = ({ category, code }) => {
  const handler = useDispatch();
  return useCallback(({ attachmentId, dictionaryProps, convertProps }) => handler({
    type: actions.CREATE_AND_CONVERT_TO_DICTIONARY, category, code, attachmentId, dictionaryProps, convertProps,
  }), [category, code]);
};

const useConvertToDictionary = ({ category, code }) => {
  const handler = useDispatch();
  return useCallback(({ attachmentId, properties, isNew }) => handler({
    type: actions.CONVERT_TO_DICTIONARY, category, code, attachmentId, properties, isNew,
  }), [category, code]);
};

export default {
  useFetchDataset: (category, { code }) => events.useDispatchByCode(
    actions.FETCH_DATASET,
    category,
    code,
  ),
  useConvertToDictionary,
  useCreateAndConvertToDictionary,
  useCreateDataset,
  useDownloadDataset,
  useEditDataset,
  useUpdateActiveDatasetStep,
  useUpdateDataset,
  useUpdateDatasetCatalogue,
  useUpdateDatasetProperties,
  useUpdateDatasetsDataModelFilter,
  useUpdataDatasetValidationErrors,
};
